module.exports = __webpack_public_path__ + "static/media/summary.8dac8617.png";